import { DEFAULT_CONCURRENCY } from "./concurrency.constants";

/**
 * `Promise.all` over a month of receipts would open hundreds of connections at
 * once; this keeps a fixed number in flight while preserving input order.
 */
export const mapWithConcurrency = async <TItem, TResult>({
  items,
  map,
  limit = DEFAULT_CONCURRENCY,
}: {
  items: TItem[];
  map: (item: TItem, index: number) => Promise<TResult>;
  limit?: number;
}): Promise<TResult[]> => {
  const results = new Array<TResult>(items.length);
  let next = 0;

  const worker = async (): Promise<void> => {
    while (next < items.length) {
      const index = next;

      next += 1;
      results[index] = await map(items[index], index);
    }
  };

  await Promise.all(
    Array.from({ length: Math.min(limit, items.length) }, worker),
  );

  return results;
};
